export default "__VITE_ASSET__BgLK10Pz__"